module.exports = __webpack_public_path__ + "static/kyuho.lee-30271a3faa6ba5b17a32a0ef7ef89220.jpeg";